<template>
  <div class="border-solid sm:w-full md:w-3/5 border-0 border-r h-full rounded">
    <div class="input-search w-full flex bg-white px-3 py-2 rounded border-0 border-b border-gray-300 border-solid">
      <feather-icon
        icon="SearchIcon"
        class="cursor-pointer"
        svg-classes="stroke-current text-primary size-icon"
      ></feather-icon>
      <input
        type="text"
        class="w-full placeholder-gray-500 border-0 m-0 ml-3 p-0 height-input rounded"
        :placeholder="$t(`TRANSFERVIEW.search`)"
        v-model="searchQuery"
      />
    </div>
    <ListaFormularios></ListaFormularios>
  </div>
</template>

<script>
import ListaFormularios from "./todo/listTodo.vue";
export default {
  components: {
    ListaFormularios
  },
  computed: {
    searchQuery: {
      get() {
        return this.$store.state.transer.todoSearchQuery;
      },
      set(val) {
        this.$store.dispatch("transer/setTodoSearchQuery", val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.height-input {
  height: 35px;
}

.size-icon {
  height: 18px;
  color: green;
}

.placeholder-gray-500::placeholder {
  color: #a0aec0;
}
.border-gray-300 {
  border-color: #e2e8f0;
}
</style>
